import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, Col, Row } from "react-bootstrap";
import { signOut } from "firebase/auth";
import { auth } from "../firebaseConfig"; // Import Firebase auth
import bg1 from "../assets/img/bg1.jpg";

export default function Signout() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleSignout = async () => {
      try {
        setError(null);
        setLoading(true); // Show loading spinner
        await signOut(auth); // Sign out user
        console.log("User signed out successfully");
        setTimeout(() => navigate("/pages/signin2"), 2000); // Redirect after a delay
      } catch (error) {
        console.error("Error during sign out:", error.message);
        setError(error.message);
        setLoading(false);
      }
    };

    handleSignout();
  }, [navigate]);

  return (
    <div className="page-sign d-block py-0">
      <Row className="g-0">
        <Col md="7" lg="5" xl="4" className="col-wrapper">
          <Card className="card-sign">
            <Card.Header>
              <Link to="/" className="header-logo mb-5">Ezarly</Link>
              <Card.Title>Signing Out</Card.Title>
              <Card.Text>Please wait while we sign you out.</Card.Text>
            </Card.Header>
            <Card.Body className="text-center">
              {loading ? (
                <div className="spinner-border text-primary mb-3" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <div className="text-danger mb-3">An error occurred: {error}</div>
              )}
              {!loading && (
                <Button 
                  variant="primary" 
                  onClick={() => navigate("/pages/signin2")}
                >
                  Go to Sign In
                </Button>
              )}
            </Card.Body>
          </Card>
        </Col>
        <Col className="d-none d-lg-block">
          <img src={bg1} className="auth-img" alt="Background" />
        </Col>
      </Row>
    </div>
  );
}
